module.exports = __webpack_public_path__ + "static/media/3040167000_01.286d2ed0.jpg";